var map = {
	"./app-icon.svg": 1740,
	"./caret-right-icon.svg": 1741,
	"./chrome-icon.webp": 1742,
	"./edge-icon.webp": 1743,
	"./firefox-icon.webp": 1744,
	"./opera-icon.webp": 1745,
	"./safari-icon.webp": 1746,
	"./unknown-icon.webp": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1739;